// src/store/index.ts
import {configureStore} from "@reduxjs/toolkit";
import {setupListeners} from "@reduxjs/toolkit/query";
import {baseApi} from "./api/baseApi";
import authSlice from "./slices/authSlice";
import uiSlice from "./slices/uiSlice";
import dashboardApi from "./api/dashboardApi";
import {authApi} from "./api/authApi";

export const store = configureStore({
  reducer: {
    // API
    [baseApi.reducerPath]: baseApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,

    // Slices
    auth: authSlice,
    ui: uiSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    })
      .concat(baseApi.middleware)
      .concat(dashboardApi.middleware),
  devTools: process.env.NODE_ENV !== "production",
});

// Setup listeners for refetchOnFocus/refetchOnReconnect behaviors
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
